import darken from "./composed/darkenjs.js";
// import swupInit from "./composed/swup.js";
import jarallax from "./composed/jarallaxjs.js";
import gridzy from "./composed/gridzy/gridzyjs.js";
import plyr from "./composed/plyrjs.js";
import placeholderLabels from "./composed/placeholder-labels.js";
import headerscroll from "./composed/headerscroll.js";
import uIkit from "./composed/uIkit.js";

document.addEventListener("DOMContentLoaded", firstLoadInit);


// const swup = swupInit(".gn-swup-wrapper");

function genericInit() {
    headerscroll.init();
    darken.init();
    gridzy.init();
    jarallax.init();
    plyr.init();
    placeholderLabels.init();
    uIkit.init();

    const gnInitEvent = new Event("gnInit");
    document.dispatchEvent(gnInitEvent);


    //adding class to style search results page
    if (window.location.href.indexOf("&action_results=Go") > -1) {
        document.body.classList.remove("SolidMenu");
    }
}


/**
 * This script cleans up JS which is will no longer be needed on page change
 */
// function cleanupScripts() {
//     jarallax.cleanup();
//     gridzy.cleanup();
//     plyr.cleanup();
//     uIkit.cleanup();
// }

// swup.on("willReplaceContent", cleanupScripts);

// init js when Swup has replaced page
// swup.on("contentReplaced", pageSwapInit);

// run some things when links are clicked.

// function pageSwapInit() {
//     genericInit();
// }

function firstLoadInit() {

    genericInit();
}
